export default __webpack_public_path__ + "static/media/covetrus-cards.56834a0b.webp";